import { ref } from 'vue'
import { contractTypeApi } from '@/services/api'

/**
 * @deprecated use useInfinityContractType instead
 */
export const useInfiniteContractType = ({ values, limit = ref(30), page = ref(0) }) => {
  const list = ref([])
  const haveMore = ref(true)
  const loading = ref(false)
  const select = (selected) => {
    const contractTypeIndex = values.findIndex(office => office._id === selected._id)
    if (contractTypeIndex > -1)
      return values.splice(contractTypeIndex, 1)
    values.push(selected)
  }
  const getMoreData = async (options) => {
    if (options.new) {
      page.value = 0
      haveMore.value = true
    }
    loading.value = true
    const contractTypeRequest = await contractTypeApi.filter({ page: page.value, limit: limit.value, search: options.search }).promise
    loading.value = false
    list.value = options.new ? contractTypeRequest.docs : [...list.value, ...contractTypeRequest.docs]
    haveMore.value = contractTypeRequest.count?.currentPage < contractTypeRequest.count?.totalPages
    page.value++
  }

  const remove = (toRemove) => {
    const foundIndex = values.findIndex(office => office._id === toRemove._id)
    if (foundIndex === -1)
      return

    values.splice(foundIndex, 1)
  }

  return {
    haveMore,
    getMoreData,
    remove,
    select,
    list,
    loading,
    values,
  }
}


export const useInfinityContractType = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]), countryId = ref('') }) => {
  const haveMore = ref(true)
  let lastRequestId = 0
  const getMoreData = async () => {
    const requestId = ++lastRequestId
    try {
      isLoading.value = true
      const searchRequest = contractTypeApi.filter({ page: page.value, limit: limit.value, search: search.value, ...(countryId.value ? { countryId: countryId.value } : {}) })
      const searchResponse = await searchRequest.promise
      // A newer request (search or country changed) replaces this one
      if (requestId !== lastRequestId)
        return
      haveMore.value = searchResponse.count.hasNextPage
      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]
      return searchResponse
    }
    catch (err) {
      console.log('err', err)
    }
    finally {
      if (requestId === lastRequestId)
        isLoading.value = false
    }
  }
  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
    countryId,
  }
}

type TContractCategory = { isFixedTerm?: boolean }

/**
 * Fixed-term contract (CDD): set on its category, `contractSuperType` in the contract type list,
 * `contractSuperTypeId` once populated with a recruitment process.
 */
export const isFixedTermContractType = (contractType?: { contractSuperType?: unknown, contractSuperTypeId?: unknown } | null) => {
  const category = contractType?.contractSuperType ?? contractType?.contractSuperTypeId
  return !!category && typeof category === 'object' && (category as TContractCategory).isFixedTerm === true
}
